var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"component-id":_vm.componentId,"app-id":_vm.appId,"sp":_vm.getSearchProfile(),"dir":_vm.textDirection}})
}
var staticRenderFns = []

export { render, staticRenderFns }